
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-2">
            <h4 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              VELETRGOVINA TT
            </h4>
            <p className="text-gray-400 mb-4 max-w-md">
              Protecting your digital privacy with advanced VPN technology. Browse securely, stream freely, and stay anonymous online.
            </p>
          </div>
          <div>
            <h5 className="font-bold text-lg mb-4">Quick Links</h5>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Home
                </a>
              </li>
              <li>
                <a href="#features" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Features
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  About
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h5 className="font-bold text-lg mb-4">Contact Info</h5>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-1"></i>
                <span>CARA DUSANA 1, Sabac, Serbia</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <a href="mailto:support@veletrgovinattdoosabac.com" className="hover:text-white cursor-pointer">
                  support@veletrgovinattdoosabac.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <a href="tel:+16362462842" className="hover:text-white cursor-pointer">
                  +1 636-246-2842
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {currentYear} VELETRGOVINA TT DOO SABAC. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white text-sm cursor-pointer transition-colors"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
